import { apiGet } from "./client";
import type { Profile, MyFee, MyFeeDetail } from "@/types/profile.types";

export function getProfile(): Promise<Profile> {
  return apiGet<Profile>("/MiniApp/GetProfile");
}

export function getMyFees(): Promise<MyFee[]> {
  return apiGet<MyFee[]>("/MiniApp/GetMyFees");
}

export async function getMyFeeDetail(id: number): Promise<MyFeeDetail | null> {
  const res = await apiGet<MyFeeDetail | { data?: MyFeeDetail | null } | { row?: MyFeeDetail | null }>(
    `/MiniApp/GetFeeDetail/${id}`
  );
  if (!res) return null;
  if (typeof res === "object" && "data" in res) return res.data ?? null;
  if (typeof res === "object" && "row" in res) return res.row ?? null;
  return res as MyFeeDetail;
}
